import { forwardRef } from 'react';
import { v4 as uuid } from 'uuid';

import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    const id = uuid();

    return (
        <SvgIcon ref={ref} {...props}>
            <g clipPath={`url(#${id})`}>
                <path d='M21.468 4.8H13.356C12.444 4.8 11.616 4.284 11.208 3.468L10.14 1.32C9.72001 0.516 8.89199 0 7.97999 0H2.26802C0.948018 0 0 1.08 0 2.4V21.6C0 22.92 0.936018 24 2.26802 24H21.468C22.788 24 24 22.92 24 21.6V7.2C24 5.88 22.788 4.8 21.468 4.8ZM21.6 20.4C21.6 21.06 20.928 21.6 20.268 21.6H3.46802C2.80802 21.6 2.4 21.06 2.4 20.4V12H21.6V20.4ZM21.6 9.6H2.4C2.4 6.936 2.4 6.264 2.4 3.6C2.4 2.94 2.80802 2.4 3.46802 2.4H7.5C7.956 2.4 8.37599 2.664 8.57999 3.072L9.94801 5.856C10.356 6.684 11.184 7.2 12.108 7.2H20.28C20.94 7.2 21.612 7.74 21.612 8.4V9.6H21.6Z' />
            </g>
            <defs>
                <clipPath id={id}>
                    <rect width='24' height='24' />
                </clipPath>
            </defs>
        </SvgIcon>
    );
});
